import React from 'react'

export default function Checkbox({name, value, label, checked, onChange}) {
    return (
        <div className="form-check">
            <input className="form-check-input" type="checkbox" value={value} id={name} checked={checked} onChange={onChange} />
            <label className="form-check-label" htmlFor={name}>{label}</label>
        </div>
    )
}
